import { Component, OnInit } from '@angular/core';
import { EaccessAuthService } from '../../auth/eaccess-auth.service';
import { ROLE_AUDIT_TRAIL_TRANSACTION_NOTES_DISTRIBUTION_SEND_NOTIFICATION } from '../../shared/constants';

@Component({
  selector: 'eaa-can-send-audit-trail-transaction-notes-distribution-notification',
  template: `
    @if (canSend) {
      <ng-content></ng-content>
    }
  `
})
export class CanSendAuditTrailTransactionNotesDistributionNotificationComponent implements OnInit {
  protected canSend: boolean | null = null;

  constructor(private authService: EaccessAuthService) {}

  public ngOnInit(): void {
    this.authService
      .hasRole$(ROLE_AUDIT_TRAIL_TRANSACTION_NOTES_DISTRIBUTION_SEND_NOTIFICATION)
      .subscribe((hasRole) => (this.canSend = hasRole));
  }
}
